import { getStore } from '~/mobx/AppStore';

export const getHeadingAndDesc = (isCandidatePage: boolean) => {
    const { ballotStore } = getStore();

    const companyName = ballotStore.company?.companyName;

    const formatDate = (dateStr?: string) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        return `${day}/${month}`;
    };

    const electionStartDateRaw = ballotStore.election?.electionStartDate;
    const electionEndDateRaw = ballotStore.election?.electionEndDate;

    const electionStartDate = formatDate(electionStartDateRaw);
    const electionEndDate = formatDate(electionEndDateRaw);
    const electionDescription = ballotStore.election?.electionSlagDescription;

    const regionName = ballotStore.region?.regionName;
    const regionDescription = ballotStore.region?.regionDescription;

    const regionHeading = regionName ? `Region ${regionName}` : undefined;
    const heading = [companyName, regionHeading].filter(Boolean).join('<br />');

    const electionPeriodText =
        companyName && electionStartDate && electionEndDate
            ? `I ${companyName} gjennomføres Coop Valg i perioden ${electionStartDate} og ${electionEndDate}.`
            : '';

    let description;

    if (isCandidatePage) {
        description = [electionDescription, electionPeriodText].filter(Boolean).join('<br>');
    } else {
        description = [electionDescription, regionDescription].filter(Boolean).join('<br>');
    }

    return { heading, description };
};
